module.exports = __webpack_public_path__ + "static/img/aqzs34.b8799d7e.jpg";